export const getEndDate = (date) => {
  const year = new Date(date).getFullYear();
  const month = new Date(date).getMonth();
  const lastDay = new Date(new Date(year, month + 1, 0) + "  GMT");

  return lastDay;
};



// WEBPACK FOOTER //
// ./src/system/utils/getEndDate.js